import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Spinner } from "@/components/ui/spinner";
import { useHolidays } from "../hooks";
import { useHolidayByIdQuery } from "../hooks/use-holiday-query";
import { useHolidayUIStore } from "../store/use-holiday-ui-store";
import { formatHolidayDateRange } from "../utils/format-holiday-date-range";

export function HolidayDeleteDialog() {
  const { isDeleteDialogOpen, deletingHolidayId, closeDeleteDialog } = useHolidayUIStore();

  const { deleteHoliday, deleting } = useHolidays();

  // Fetch holiday data for display
  const { data: holidayData, loading: holidayLoading } = useHolidayByIdQuery(
    deletingHolidayId || undefined
  );

  const holiday = holidayData?.getHoliday;

  const handleDelete = async () => {
    if (!deletingHolidayId) return;

    try {
      await deleteHoliday(deletingHolidayId);
      closeDeleteDialog();
    } catch (error) {
      // Error is handled by the mutation hook
      console.error("Holiday delete error:", error);
    }
  };

  const handleClose = () => {
    if (!deleting) {
      closeDeleteDialog();
    }
  };

  return (
    <AlertDialog open={isDeleteDialogOpen} onOpenChange={handleClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Holiday</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              {holidayLoading ? (
                <div className="flex items-center justify-center py-4">
                  <Spinner size="lg" />
                </div>
              ) : holiday ? (
                <>
                  <p>
                    Are you sure you want to delete <strong>"{holiday.name}"</strong>?
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {formatHolidayDateRange(holiday.startDateTime, holiday.endDateTime)}
                  </p>
                  {holiday.message && (
                    <p className="text-sm text-muted-foreground italic">"{holiday.message}"</p>
                  )}
                  <p className="text-sm font-medium text-destructive">
                    This action cannot be undone.
                  </p>
                </>
              ) : (
                <p>Holiday not found.</p>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleting || !holiday}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {deleting && <Spinner className="w-4 h-4 mr-2" />}
            Delete Holiday
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
